// Audio Contextは一度だけ初期化する
let audioContext = null;
const soundCache = new Map();

function initAudioContext() {
  if (!audioContext) {
    audioContext = new (window.AudioContext || window.webkitAudioContext)();
  }
}

// 音声生成関数: 撥弦楽器のような音
export async function createPluckSound(frequency, duration = 0.8) {
  initAudioContext();
  const key = `pluck_${frequency}`;
  if (soundCache.has(key)) return soundCache.get(key);

  const sampleRate = audioContext.sampleRate;
  const numSamples = Math.floor(duration * sampleRate);
  const offlineContext = new OfflineAudioContext(2, numSamples, sampleRate);

  const osc1 = offlineContext.createOscillator();
  const osc2 = offlineContext.createOscillator();
  const gain1 = offlineContext.createGain();
  const gain2 = offlineContext.createGain();

  osc1.frequency.value = frequency;
  osc2.frequency.value = frequency * 2;

  const attackTime = 0.01;
  const now = offlineContext.currentTime;

  gain1.gain.setValueAtTime(0, now);
  gain1.gain.linearRampToValueAtTime(0.6, now + attackTime);
  gain1.gain.exponentialRampToValueAtTime(0.001, now + duration);

  gain2.gain.setValueAtTime(0, now);
  gain2.gain.linearRampToValueAtTime(0.3, now + attackTime);
  gain2.gain.exponentialRampToValueAtTime(0.001, now + duration);

  osc1.connect(gain1);
  osc2.connect(gain2);
  gain1.connect(offlineContext.destination);
  gain2.connect(offlineContext.destination);

  osc1.start(0);
  osc2.start(0);
  osc1.stop(duration);
  osc2.stop(duration);

  const buffer = await offlineContext.startRendering();
  soundCache.set(key, buffer);
  return buffer;
}

// 音声生成関数: スティールパンのような音
export async function createSteelpanSound(frequency, duration = 1.0) {
  initAudioContext();
  const key = `steel_${frequency}`;
  if (soundCache.has(key)) return soundCache.get(key);

  const sampleRate = audioContext.sampleRate;
  const numSamples = Math.floor(duration * sampleRate);
  const offlineContext = new OfflineAudioContext(2, numSamples, sampleRate);

  const partials = [
    { freq: frequency, gain: 0.7 },
    { freq: frequency * 2.01, gain: 0.42 },
    { freq: frequency * 3.03, gain: 0.28 },
  ];

  partials.forEach((partial) => {
    const osc = offlineContext.createOscillator();
    const gain = offlineContext.createGain();

    osc.frequency.value = partial.freq;

    const now = offlineContext.currentTime;
    gain.gain.setValueAtTime(partial.gain, now);
    gain.gain.exponentialRampToValueAtTime(0.001, now + duration);

    osc.connect(gain);
    gain.connect(offlineContext.destination);

    osc.start(0);
    osc.stop(duration);
  });

  const buffer = await offlineContext.startRendering();
  soundCache.set(key, buffer);
  return buffer;
}

// 生成した音声バッファを再生
export function playBuffer(buffer, volume = 1.0) {
  initAudioContext();
  const source = audioContext.createBufferSource();
  const gainNode = audioContext.createGain();

  source.buffer = buffer;
  gainNode.gain.value = volume;

  source.connect(gainNode);
  gainNode.connect(audioContext.destination);
  source.start();
}
